// extracted by mini-css-extract-plugin
export default {"folderTable":"FolderList_folderTable__eXT42","folderTableFolderName":"FolderList_folderTableFolderName__FLVDd"};